import authAxios from "../axios/authAxios";

class ChatApi {
    static getGeneralChat(accessToken, prompt) {
        return authAxios.get("/v1/chat/general/", {
            params: {
                prompt: prompt,
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }
    static getEquipmentHistory(accessToken, prompt) {
        return authAxios.get("/v1/chat/history/", {
            params: {
                prompt: prompt,
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }
    static getBedrockChat(accessToken, chat_type, prompt, history) {
        return authAxios.get("/v1/chat/chat/", {
            params: {
                chat_type: chat_type,
                prompt: prompt,
                history: history,
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }
    static getBedrockChat2(accessToken, prompt, history) {
        return authAxios.get("/v2/chat/", {
            params: {
                prompt: prompt,
                history: history,
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }
}

export default ChatApi;
